export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-1.0.0',
    name: 'JDSDropdown',
    description:
      'Dropdowns allow users to choose from a list of options presented contextually as a list. A dropdown in this document is a combination of a trigger and an options popup.',
    usage:
      'Dropdowns are used when you want users to take an action or provide input.'
  },
  hierarchy: {
    container: [
      {
        'field-container': [
          'label-jds-text',
          {
            'select-container': [
              {
                'text-container': [
                  {
                    'prefix-icon-container': ['prefix-icon']
                  },
                  'current-jds-text',
                  'placeholder-jds-text'
                ]
              },
              {
                'chevron-jds-icon-container': ['chevron-jds-icon']
              }
            ]
          }
        ]
      },
      {
        'active-line-container': ['feedback-container']
      },
      'jds_feedback_block',
      'helper-jds-text',
      'jds_menu_block'
    ]
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      gap: '{d_1}',
      width: '{d_2}',
      'justify-content': '{d_3}',
      'align-items': '{d_4}',
      behavior: {
        hover: {}
      },
      opacity: '{d_27}'
    },
    'field-container': {
      'flex-direction': '{d_5}',
      width: '{d_6}',
      'align-items': '{d_7}',
      'justify-content': '{d_8}',
      'padding-bottom': '{d_9}'
    },
    'text-container': {
      'flex-direction': '{d_10}',
      flex: 1,
      gap: '{d_11}'
    },
    'select-container': {
      'flex-direction': '{d_12}',
      'justify-content': '{d_13}',
      width: '{d_14}',
      'padding-top': 20,
      'align-items': '{d_15}',
      'z-index': 0
    },
    'active-line-container': {
      'flex-direction': '{d_16}',
      width: '{d_17}',
      'align-items': '{d_18}',
      'padding-top': 1,
      'padding-bottom': 1
    },
    'feedback-container': {
      width: '{d_19}',
      height: 2,
      'background-color': '{d_20}',
      'border-radius': 48,
      show: true,
      behavior: {
        hover: {
          'background-color': '{d_21}'
        },
        focus: {
          'background-color': '{d_22}'
        },
        active: {
          'background-color': '{d_23}'
        }
      }
    },
    jds_feedback_block: {
      size: 's',
      state: 'none'
    },
    jds_menu_block: {
      open: false
    },
    'prefix-icon-container': {
      hidden: true
    },
    'prefix-icon': {
      size: '{d_24}',
      color: '{d_25}'
    },
    'label-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      maxLines: 1,
      'z-index': 1
    },
    'current-jds-text': {
      'font-family': '{text_132}',
      color: '{text_20}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'max-lines': 1,
      hidden: true,
      maxLines: 1
    },
    'placeholder-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'chevron-jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}',
      value: 'ic_chevron_down',
      ic: 'ic_chevron_down'
    },
    'chevron-jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      ic: 'ic_chevron_down'
    },
    'helper-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    open: {
      true: {
        jds_menu_block: {
          open: true
        },
        'chevron-jds-icon': {
          value: 'ic_chevron_up',
          ic: 'ic_chevron_up'
        },
        'chevron-jds-icon-container': {
          ic: 'ic_chevron_up'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{d_26}'
        },
        'select-container': {
          disabled: true
        }
      }
    },
    state: {
      success: {
        'feedback-container': {
          'background-color': '{d_28}',
          behavior: {
            hover: {
              'background-color': '{d_29}'
            },
            focus: {
              'background-color': '{d_30}'
            },
            active: {
              'background-color': '{d_31}'
            }
          }
        },
        jds_feedback_block: {
          state: 'success'
        }
      },
      error: {
        'feedback-container': {
          'background-color': '{d_32}',
          behavior: {
            hover: {
              'background-color': '{d_33}'
            },
            focus: {
              'background-color': '{d_34}'
            },
            active: {
              'background-color': '{d_35}'
            }
          }
        },
        jds_feedback_block: {
          state: 'error'
        }
      },
      warning: {
        'feedback-container': {
          'background-color': '{d_36}',
          behavior: {
            hover: {
              'background-color': '{d_37}'
            },
            focus: {
              'background-color': '{d_38}'
            },
            active: {
              'background-color': '{d_39}'
            }
          }
        },
        jds_feedback_block: {
          state: 'warning'
        }
      }
    },
    _isLabelEmpty: {
      true: {
        'label-jds-text': {
          hidden: true
        }
      }
    },
    _isPlaceHolderEmpty: {
      true: {
        'placeholder-jds-text': {
          hidden: true
        }
      }
    },
    _isValueEmpty: {
      false: {
        'current-jds-text': {
          hidden: false
        },
        'placeholder-jds-text': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      true: {
        true: {
          'field-container': {
            'align-items': '{d_40}'
          },
          'prefix-icon-container': {
            hidden: false
          },
          'label-jds-text': {
            'font-family': '{text_147}',
            'font-size': '{text_146}',
            'line-height': '{text_148}',
            'letter-spacing': '{text_149}',
            'font-weight': '{text_150}',
            'padding-left': 0
          }
        },
        false: {
          'field-container': {
            'align-items': '{d_41}'
          },
          'label-jds-text': {
            'font-family': '{text_147}',
            'font-size': '{text_146}',
            'line-height': '{text_148}',
            'letter-spacing': '{text_149}',
            'font-weight': '{text_150}',
            'padding-left': 0
          }
        }
      },
      false: {
        true: {
          'field-container': {
            'align-items': '{d_42}'
          },
          'prefix-icon-container': {
            hidden: false
          },
          'label-jds-text': {
            'padding-left': '{d_43}'
          }
        },
        false: {
          'field-container': {
            'align-items': '{d_44}'
          },
          'label-jds-text': {
            'padding-left': 0
          }
        }
      }
    },
    {
      none: {
        true: {
          'feedback-container': {
            'background-color': '{d_45}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['_labelFocus', '_hasPrefix'],
    ['state', '_inputFocus']
  ],
  api: {
    config: {
      open: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        values: ['none', 'success', 'error', 'warning']
      },
      _labelFocus: {
        values: [false, true]
      },
      _inputFocus: {
        values: [false, true]
      },
      _hasPrefix: {
        values: [false, true]
      },
      _isLabelEmpty: {
        values: [false, true]
      },
      _isPlaceHolderEmpty: {
        values: [false, true]
      },
      _isValueEmpty: {
        values: [false, true]
      }
    },
    data: {
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText'
        }
      },
      'prefix-icon': {
        value: {
          type: 'icon',
          name: 'prefix'
        }
      },
      jds_menu_block: {
        items: {
          type: 'list',
          name: 'items',
          doc_description:
            'This should pass down values to MenuBlock’s items prop. selected determines the default selected value currently.',
          object: {
            type: 'JDSMenuBlockItem.type',
            label: 'string',
            value: 'string',
            prefix: 'icon',
            suffix: 'icon',
            disabled: 'boolean'
          }
        },
        selectedIndex: {
          type: 'number',
          name: 'selectedIndex'
        },
        offsetX: {
          type: 'size',
          name: '_offsetX'
        },
        offsetY: {
          type: 'size',
          name: '_offsetY'
        },
        minWidth: {
          type: 'size',
          name: '_minWidth'
        },
        maxWidth: {
          type: 'size',
          name: '_maxWidth'
        },
        maxHeight: {
          type: 'size',
          name: '_maxHeight'
        }
      },
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'current-jds-text': {
        value: {
          type: 'string',
          name: 'current'
        }
      },
      'placeholder-jds-text': {
        value: {
          type: 'string',
          name: 'placeholder'
        }
      },
      'helper-jds-text': {
        value: {
          type: 'string',
          name: 'helperText'
        }
      }
    },
    events: {
      'active-line-container': {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        }
      },
      'select-container': {
        onClick: 'onOpen'
      },
      jds_menu_block: {
        onSelect: 'onSelect',
        onClose: 'onClose'
      }
    },
    a11y: {
      'select-container': {
        properties: {
          role: {
            value: 'menu'
          },
          'aria-label': {
            name: 'ariaLabel',
            value: 'Toggle Dropdown'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-haspopup': {
            name: '_ariaHaspopup',
            prop: 'open'
          },
          'aria-expanded': {
            name: '_ariaExpanded',
            prop: 'open'
          }
        }
      },
      jds_menu_block: {
        name: 'items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
